 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		196: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"chunk-web-stories-template-102","1":"chunk-web-stories-template-110","2":"chunk-web-stories-template-118","3":"chunk-web-stories-template-126","4":"chunk-web-stories-template-134","5":"chunk-web-stories-template-14","6":"chunk-web-stories-template-142","7":"chunk-web-stories-template-150","8":"chunk-web-stories-template-158","9":"chunk-web-stories-template-166","10":"chunk-web-stories-template-174","11":"chunk-web-stories-template-182","12":"chunk-web-stories-template-190","13":"chunk-web-stories-template-198","14":"chunk-web-stories-template-206","15":"chunk-web-stories-template-214","16":"chunk-web-stories-template-22","17":"chunk-web-stories-template-222","18":"chunk-web-stories-template-230","19":"chunk-web-stories-template-238","20":"chunk-web-stories-template-246","21":"chunk-web-stories-template-254","22":"chunk-web-stories-template-262","23":"chunk-web-stories-template-270","24":"chunk-web-stories-template-278","25":"chunk-web-stories-template-286","26":"chunk-web-stories-template-294","27":"chunk-web-stories-template-30","28":"chunk-web-stories-template-302","29":"chunk-web-stories-template-310","30":"chunk-web-stories-template-318","31":"chunk-web-stories-template-326","32":"chunk-web-stories-template-334","33":"chunk-web-stories-template-342","34":"chunk-web-stories-template-350","35":"chunk-web-stories-template-358","36":"chunk-web-stories-template-366","37":"chunk-web-stories-template-374","38":"chunk-web-stories-template-38","39":"chunk-web-stories-template-382","40":"chunk-web-stories-template-390","41":"chunk-web-stories-template-398","42":"chunk-web-stories-template-406","43":"chunk-web-stories-template-414","44":"chunk-web-stories-template-422","45":"chunk-web-stories-template-430","46":"chunk-web-stories-template-438","47":"chunk-web-stories-template-446","48":"chunk-web-stories-template-454","49":"chunk-web-stories-template-46","50":"chunk-web-stories-template-462","51":"chunk-web-stories-template-470","52":"chunk-web-stories-template-478","53":"chunk-web-stories-template-486","54":"chunk-web-stories-template-54","55":"chunk-web-stories-template-6","56":"chunk-web-stories-template-62","57":"chunk-web-stories-template-70","58":"chunk-web-stories-template-78","59":"chunk-web-stories-template-86","60":"chunk-web-stories-template-94","61":"chunk-web-stories-template-0","62":"chunk-web-stories-template-104","63":"chunk-web-stories-template-112","64":"chunk-web-stories-template-120","65":"chunk-web-stories-template-128","66":"chunk-web-stories-template-136","67":"chunk-web-stories-template-144","68":"chunk-web-stories-template-152","69":"chunk-web-stories-template-16","70":"chunk-web-stories-template-160","71":"chunk-web-stories-template-168","72":"chunk-web-stories-template-176","73":"chunk-web-stories-template-184","74":"chunk-web-stories-template-192","75":"chunk-web-stories-template-200","76":"chunk-web-stories-template-208","77":"chunk-web-stories-template-216","78":"chunk-web-stories-template-224","79":"chunk-web-stories-template-232","80":"chunk-web-stories-template-24","81":"chunk-web-stories-template-240","82":"chunk-web-stories-template-248","83":"chunk-web-stories-template-256","84":"chunk-web-stories-template-264","85":"chunk-web-stories-template-272","86":"chunk-web-stories-template-280","87":"chunk-web-stories-template-288","88":"chunk-web-stories-template-296","89":"chunk-web-stories-template-304","90":"chunk-web-stories-template-312","91":"chunk-web-stories-template-32","92":"chunk-web-stories-template-320","93":"chunk-web-stories-template-328","94":"chunk-web-stories-template-336","95":"chunk-web-stories-template-344","96":"chunk-web-stories-template-352","97":"chunk-web-stories-template-360","98":"chunk-web-stories-template-368","99":"chunk-web-stories-template-376","100":"chunk-web-stories-template-384","101":"chunk-web-stories-template-392","102":"chunk-web-stories-template-40","103":"chunk-web-stories-template-400","104":"chunk-web-stories-template-408","105":"chunk-web-stories-template-416","106":"chunk-web-stories-template-424","107":"chunk-web-stories-template-432","108":"chunk-web-stories-template-440","109":"chunk-web-stories-template-448","110":"chunk-web-stories-template-456","111":"chunk-web-stories-template-464","112":"chunk-web-stories-template-472","113":"chunk-web-stories-template-48","114":"chunk-web-stories-template-480","115":"chunk-web-stories-template-56","116":"chunk-web-stories-template-64","117":"chunk-web-stories-template-72","118":"chunk-web-stories-template-8","119":"chunk-web-stories-template-80","120":"chunk-web-stories-template-88","121":"chunk-web-stories-template-96","122":"chunk-web-stories-template-100","123":"chunk-web-stories-template-108","124":"chunk-web-stories-template-116","125":"chunk-web-stories-template-12","126":"chunk-web-stories-template-124","127":"chunk-web-stories-template-132","128":"chunk-web-stories-template-140","129":"chunk-web-stories-template-148","130":"chunk-web-stories-template-156","131":"chunk-web-stories-template-164","132":"chunk-web-stories-template-172","133":"chunk-web-stories-template-180","134":"chunk-web-stories-template-188","135":"chunk-web-stories-template-196","136":"chunk-web-stories-template-20","137":"chunk-web-stories-template-204","138":"chunk-web-stories-template-212","139":"chunk-web-stories-template-220","140":"chunk-web-stories-template-228","141":"chunk-web-stories-template-236","142":"chunk-web-stories-template-244","143":"chunk-web-stories-template-252","144":"chunk-web-stories-template-260","145":"chunk-web-stories-template-268","146":"chunk-web-stories-template-276","147":"chunk-web-stories-template-28","148":"chunk-web-stories-template-284","149":"chunk-web-stories-template-292","150":"chunk-web-stories-template-300","151":"chunk-web-stories-template-308","152":"chunk-web-stories-template-316","153":"chunk-web-stories-template-324","154":"chunk-web-stories-template-332","155":"chunk-web-stories-template-340","156":"chunk-web-stories-template-348","157":"chunk-web-stories-template-356","158":"chunk-web-stories-template-36","159":"chunk-web-stories-template-364","160":"chunk-web-stories-template-372","161":"chunk-web-stories-template-380","162":"chunk-web-stories-template-388","163":"chunk-web-stories-template-396","164":"chunk-web-stories-template-4","165":"chunk-web-stories-template-404","166":"chunk-web-stories-template-412","167":"chunk-web-stories-template-420","168":"chunk-web-stories-template-428","169":"chunk-web-stories-template-436","170":"chunk-web-stories-template-44","171":"chunk-web-stories-template-444","172":"chunk-web-stories-template-452","173":"chunk-web-stories-template-460","174":"chunk-web-stories-template-468","175":"chunk-web-stories-template-476","176":"chunk-web-stories-template-484","177":"chunk-web-stories-template-52","178":"chunk-web-stories-template-60","179":"chunk-web-stories-template-68","180":"chunk-web-stories-template-76","181":"chunk-web-stories-template-84","182":"chunk-web-stories-template-92","183":"chunk-colorthief","184":"chunk-ffmpeg","185":"chunk-focus-visible","186":"chunk-fonts","187":"chunk-web-stories-textset-0","188":"chunk-web-stories-textset-1","189":"chunk-web-stories-textset-2","190":"chunk-web-stories-textset-3","191":"chunk-web-stories-textset-4","192":"chunk-web-stories-textset-5","193":"chunk-web-stories-textset-6","194":"chunk-web-stories-textset-7"}[chunkId]||chunkId) + "." + {"0":"44dbd54a","1":"b5530d90","2":"91aac0c2","3":"5c8ccffa","4":"aab0451e","5":"de533cb4","6":"d566dd56","7":"1d6134af","8":"75ab40f6","9":"c8b634d5","10":"47f7494e","11":"74ace713","12":"9a117447","13":"cf2aeec8","14":"5d0d3edd","15":"3508cdfc","16":"62a25210","17":"a2a902d8","18":"3c8317d9","19":"419eeb43","20":"c88a0327","21":"210b9efa","22":"a13f7fc7","23":"da8ec137","24":"a6904428","25":"909e5145","26":"d1b2e140","27":"7f6ac5e1","28":"205cd8da","29":"d93efb19","30":"0d45e6e1","31":"83693c7d","32":"a66f7765","33":"8b944ba4","34":"97b6eef6","35":"18ee4428","36":"9869eae2","37":"57f7b9bb","38":"1c7d6e38","39":"815aac66","40":"fba6d65f","41":"052d5b59","42":"9f23fb49","43":"33efb0e3","44":"4ae5f946","45":"296751dc","46":"3063cc2d","47":"ce95dbb9","48":"3e6534b0","49":"46fcfc4c","50":"4bc9f79a","51":"53b06609","52":"dc89e818","53":"b9eb8df8","54":"27bc6742","55":"3b506ef7","56":"2ec51b0e","57":"d529ca1a","58":"a200f2dd","59":"92eda2d4","60":"08e2fbc3","61":"53fc7cf1","62":"50230188","63":"af326227","64":"b801176e","65":"6183d01d","66":"4f3aa962","67":"b66c2ab5","68":"d4a0110e","69":"aad760b1","70":"4d4a0898","71":"b028d1e6","72":"67a83808","73":"6d77fffb","74":"0e53e281","75":"ac9697cf","76":"01c317d6","77":"9537786c","78":"abd19a16","79":"9fd83a9d","80":"a68702c2","81":"18294115","82":"f82109a2","83":"8a79c2dd","84":"c24b60bf","85":"5c1bec43","86":"4fc2ff53","87":"4f10292d","88":"4c67731b","89":"9f0c13b7","90":"615e0ab1","91":"8f460331","92":"b0cc181d","93":"58b0dbf0","94":"123ad8b8","95":"d9d2eb3e","96":"714c90d8","97":"a20b85e0","98":"013ef805","99":"68a500e5","100":"72b7d5d8","101":"8726bb0d","102":"3303984f","103":"772dd04f","104":"f7a4b6c1","105":"cbc53422","106":"8a5de915","107":"a4a1a455","108":"2e27a3a7","109":"9c3746d4","110":"b9eeb57c","111":"748844dc","112":"beca713e","113":"d2141b2e","114":"e51e395f","115":"5f8893fd","116":"89f42b43","117":"1595d20f","118":"5e1810a9","119":"ac91d4f0","120":"7a17f46c","121":"cb67bd47","122":"d55a8e15","123":"c75920c8","124":"5147f90e","125":"7484fe88","126":"8da950c4","127":"27b3764d","128":"79768f10","129":"bdcaf3e9","130":"d0c8fd0e","131":"219271c8","132":"1efb37cf","133":"477c639c","134":"1ba78691","135":"a16e473c","136":"f228f415","137":"b58b0f5c","138":"17523442","139":"3e0b3e19","140":"2c8e7989","141":"2c3e0eec","142":"d80cac59","143":"98f41444","144":"1a9bbe55","145":"e28d1134","146":"81cdc7b0","147":"c3c99ece","148":"95415715","149":"206eeab8","150":"2ec3af7e","151":"00e3c440","152":"2bd30a5f","153":"9df789cf","154":"85b47cc6","155":"8a87a4f1","156":"8011ce56","157":"65b33a63","158":"58aa85b4","159":"60345e9d","160":"aefd82f4","161":"58b12fa4","162":"aed0c6f1","163":"6f80f99e","164":"626cb9c7","165":"c76d5234","166":"f6c14a68","167":"9fbd7470","168":"0cfd25e2","169":"37925f4f","170":"02d7c669","171":"dab572ca","172":"18e665a4","173":"f0d74721","174":"8a0e6d82","175":"b64a35dc","176":"e5a29a9e","177":"9a5ddbf4","178":"3c66983c","179":"36f8e73b","180":"46615703","181":"f1131320","182":"e2cad8ad","183":"09e57382","184":"b404ba66","185":"2566ac81","186":"7101deaa","187":"0ad73b90","188":"95858f48","189":"7e44514d","190":"98be0995","191":"f87f14e8","192":"db053582","193":"8c2b318b","194":"e2b9d40e","198":"1800c25e","199":"a17ab048","200":"b52c063a","201":"5aa1b1c7","202":"a3f25d24","203":"fa81f0b0"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpstoryteller-studio"] = this["webpackJsonpstoryteller-studio"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
